import { render } from "./Kehu.vue?vue&type=template&id=ae5ca12e&scoped=true"
import script from "./Kehu.vue?vue&type=script&lang=js"
export * from "./Kehu.vue?vue&type=script&lang=js"

import "./Kehu.vue?vue&type=style&index=0&id=ae5ca12e&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5ca12e"]])

export default __exports__